import { IAccessCodeResponse } from '../types/IAccessCodeResponse';
import { BaseApi } from '../BaseApi';

export const AccessCodeApi = BaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAccessCodeData: build.query<IAccessCodeResponse, string>({
      query: (accessCode) => ({
        url: `/emd-buyer-details?accesscode=${accessCode}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetAccessCodeDataQuery } = AccessCodeApi;
